import * as React from "react";
import ReactDOM from "react-dom";
import FocusLock from "react-focus-lock";
import { useIntl } from "react-intl";
import styled, { createGlobalStyle } from "styled-components";

import Images from "../assets/images/images";
import { BaseButton } from "../button/BaseButton";
import { InfoIconText } from "./InfoIcon.sc";

const BodyStyle = createGlobalStyle<{ isOpen: boolean }>`
    && body {
        ${({ isOpen }) => isOpen && "overflow: hidden"}
    }
`;

interface InfoIconPortalProps {
    infoText: React.ReactNode;
    isOpen: boolean;
    onClose: () => void;
}

export const InfoIconPortal = ({ infoText, isOpen, onClose }: InfoIconPortalProps) => {
    const intl = useIntl();
    if (!isOpen) return null;
    return ReactDOM.createPortal(
        <InfoIconWrapper id="infoIconPortal" role="dialog">
            <FocusLock disabled={!isOpen} returnFocus>
                <BodyStyle isOpen={isOpen} />
                <BackdropHandler
                    onClick={(e) => {
                        e.stopPropagation();
                        onClose();
                    }}
                />
                <CloseButton
                    aria-label={intl.formatMessage({ id: "infoIcon.closeTooltip", defaultMessage: "Info schließen" })}
                    onClick={(e) => {
                        e.stopPropagation();
                        onClose();
                    }}
                />
                <InfoIconText isOpen={isOpen}>{infoText}</InfoIconText>
            </FocusLock>
        </InfoIconWrapper>,
        document.body,
    );
};

const BackdropHandler = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.2);
`;

const InfoIconWrapper = styled.div`
    position: fixed;
    z-index: 15;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
`;

const CloseButton = styled(BaseButton)`
    position: fixed;
    top: 60px;
    right: 10px;
    background-position: center;
    background-size: 30px 30px;
    background-repeat: no-repeat;
    background-image: url(${Images.Close});
    z-index: 1250;
    height: 48px;
    width: 48px;
    filter: drop-shadow(3px 2px 2px rgb(0 0 0 / 0.3));
`;
